import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_38 implements Validator {

	public static id = 'CTRL_38';
	private message = 'error.ctr_38';


	public LOG: LogService = new LogService(CTRL_38);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_38.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const firstNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
				const secondNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
				const thirdNameWithStepId = map.get(ctrl.value.rgCtrls.troisiemeChamp);
				const fourthNameWithStepId = map.get(ctrl.value.rgCtrls.quatriemeChamp);
				const fifthNameWithStepId = map.get(ctrl.value.rgCtrls.cinquiemeChamp);
				const sixthNameWithStepId = map.get(ctrl.value.rgCtrls.sixiemeChamp);


				const controlsNameNom = [];
				const nom = rg.substr(rg.length - 1);

				controlsNameNom.push(firstNameWithStepId);
				controlsNameNom.push(secondNameWithStepId.replace('INDEX_38_1', nom));
				controlsNameNom.push(thirdNameWithStepId.replace('INDEX_38_1', nom));
				controlsNameNom.push(fourthNameWithStepId);
				controlsNameNom.push(fifthNameWithStepId);
				controlsNameNom.push(sixthNameWithStepId);

				const valuesNom = [];


				for (let i = 0; i < controlsNameNom.length; i++) {
					if (Array.isArray(form.controls[map.get(controlsNameNom[i])].value)) {
						form.controls[map.get(controlsNameNom[i])].value.forEach(function(item){
							valuesNom.push(item);
						});
					} else {
						valuesNom.push(form.controls[map.get(controlsNameNom[i])].value);
					}
				}
				if (valuesNom.filter((item, i, ar) => ar.indexOf(item) === i).length === valuesNom.length) {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				} else {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				}
			}
		}
	}
}
